module.exports = __webpack_public_path__ + "static/media/My Docs inside.b0c1dcaf.png";